import Round from "./Round";
import Hint from "./Hint";

export type { RoundProps } from "./Round";
export type { HintProps } from "./Hint";

const Badge = {
  Round,
  Hint,
};

export default Badge;

// 개별 import 지원
export { Round, Hint };
